export default __webpack_public_path__ + "static/media/spider.6c6e4455.ogg";